import {ProfileCustomerLifecycleCards} from "~/components/entityProfile/lifecycle/profileCustomerLifecycleCards";
import type {CustomerProfileLifecycleItem} from "~/components/entityProfile/lifecycle/types";
import {ProfileOverviewSectionHeader} from "~/components/entityProfile/overview/profileOverviewSectionHeader";
import {AnankeButton} from "@vesta/ananke/components/anankeButton";

export function ProfileOverviewRecentLifecycles({
    lifecycles,
    onViewAll,
}: {
    lifecycles: CustomerProfileLifecycleItem[];
    onViewAll?: () => void;
}) {
    if (lifecycles.length === 0) {
        return null;
    }

    return (
        <section className="grid w-full min-w-0 gap-y-ds-space-150">
            <ProfileOverviewSectionHeader title="Recent Lifecycles" />
            <ProfileCustomerLifecycleCards lifecycles={lifecycles} />
            {onViewAll !== undefined ? (
                <div className="grid w-full [&_button]:w-full [&_button]:justify-center">
                    <AnankeButton type="button" appearance="default" onClick={onViewAll}>
                        View All
                    </AnankeButton>
                </div>
            ) : null}
        </section>
    );
}
